import type { ReactElement, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Card } from 'antd';

export interface WidgetContainerProps {
  title?: string;
  icon?: LucideIcon;
  iconColor?: string;
  children: ReactNode;
  headerRight?: ReactNode;
  minHeight?: number;
  noPadding?: boolean;
  className?: string;
  testId?: string;
}

export function WidgetContainer({
  title,
  icon: Icon,
  iconColor,
  children,
  headerRight,
  minHeight = 200,
  noPadding = false,
  className,
  testId,
}: WidgetContainerProps): ReactElement {
  return (
    <Card
      className={className ?? ''}
      data-testid={testId}
      title={
        title ? (
          <h2 className="flex items-center gap-2 font-semibold" style={{ color: '#1f1a14', fontSize: 13, margin: 0 }}>
            {Icon && <Icon size={16} strokeWidth={2} style={{ color: iconColor ?? '#d97706' }} />}
            {title}
          </h2>
        ) : null
      }
      extra={headerRight}
      styles={{
        header: {
          padding: '16px 28px',
          borderBottom: '1px solid #e7e4db',
          minHeight: 'auto',
        },
        body: {
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          padding: noPadding ? 0 : 28,
        },
      }}
      style={{
        borderRadius: 14,
        background: '#ffffff',
        border: '1px solid #e7e4db',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight,
        overflow: 'hidden',
      }}
    >
      {children}
    </Card>
  );
}
